//
// PositionedModelOwnerController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./PositionedModelController";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "../../models/view/layout/PositionedModelOwner";
import "./VisualController";
import "./ContainerController";
import "../../util/layout/ResponsiveLayoutScrollDirection";

var PositionedModelOwnerController = createModule("BIRD::PositionedModelOwnerController", ["BIRD::BIRDModelController","BIRD::PositionedModelController"], EventDispatcher, [
    ,
    ,
    ,
    {
        stackActiveVisualIndex: 4,
        relativeVerticalOffset: 1,
        slideOffset: 1,
        relativeHorizontalOffset: 1,
    },
    {
        getVisualControllers: [[1]],
        getAllVisualControllers: [[1]],
        layout: [0,13,1],
        getOrderedVisualAndContainerControllers: [[1]],
        getModel: [1],
        getContainerControllers: [[1]],
        getSlidedContainerControllers: [[1]],
        getResponsiveLayoutScrollDirection: [4],
        getPromptContainerControllers: [[1]],
        getStackContainerControllers: [[1]],
        getAllViewVisualControllers: [[1]],
        getCompositeContainerControllers: [[1]],
    },
    ,
    ,
]);
export default PositionedModelOwnerController;
